import {isValidColor} from '../components/LabelColorPicker'
import {LABELS} from '../constants/labels'
import {LABEL_NAME_MAX_LENGTH as SHARED_LABEL_NAME_MAX_LENGTH, validateLabelName} from './validate-label-name'

export const LABEL_NAME_MAX_LENGTH = SHARED_LABEL_NAME_MAX_LENGTH

export function validateLabelColor(color: string) {
  return color.trim() ? (isValidColor(color) ? null : LABELS.invalidHexColor) : LABELS.colorRequired
}

export function validateLabelForm(name: string, color: string) {
  return {
    nameError: validateLabelName(name),
    colorError: validateLabelColor(color),
  }
}
